

































































import {Component, Mixins, Prop, Ref, Watch} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import PopupHandler from '@/mixins/popupHandler'
import ModifiedDataHandler from '@/mixins/ModifiedDataHandler'
import FooterFixedHandler from '@/mixins/FooterFixedHandler'
import MainLayout from '@/layouts/default/MainLayout.vue'
import HeaderLayout from '@/components/Header.vue'
import TitleAndMessage from '@/components/TitleAndMessage.vue'
import FooterLayout from '@/components/Footer.vue'
import FooterButton from '@/components/FooterButton.vue'
import SearchAddressPopup from '@/components/popup/btt/SearchAddress.vue'
import TaxRNumInfoPopup from '@/components/popup/btt/TaxRNumInfo.vue'
import {Form, FormItem} from 'element-ui'
import FloatingLabelInput from '@/components/FloatingLabelInput.vue'
import toBizRNumDash from '@/filters/to-biz-r-num-dash'
import {mask} from 'vue-the-mask'
import {UpdatePayload} from '@/store/modules/biz/types'
import {LogEventWidthGroupsPayload} from '@/store/modules/gtm/types'
import {namespace} from 'vuex-class'

const biz = namespace('biz')
const layout = namespace('layout')
const gtm = namespace('gtm')
const issue = namespace('issue')

@Component({
  components: {
    SearchAddressPopup,
    MainLayout,
    HeaderLayout,
    FooterLayout,
    FooterButton,
    TitleAndMessage,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    FloatingLabelInput,
    TaxRNumInfoPopup,
  },
  directives: {mask},
  methods: {toBizRNumDash},
})
export default class IssueBizInfo extends Mixins(Translation, PopupHandler, ModifiedDataHandler, FooterFixedHandler) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: 0, type: Number}) windowScrollY: number
  @Prop({default: false, type: Boolean}) isConfirm: boolean

  @Ref('formRef') readonly formRef!: Form

  @biz.Action('getBiz') getBiz
  @biz.Action('updateBiz') updateBiz: (payload: UpdatePayload) => Promise<void>
  @biz.State('name') bizName
  @biz.State('bizRegistrationNumber') bizRegistrationNumber
  @biz.State('ownerName') ownerName
  @biz.State('address') address
  @biz.State('bizClass') bizClass
  @biz.State('bizType') bizType
  @biz.State('ownerEmail') ownerEmail
  @biz.State('taxRegistrationNumber') taxRegistrationNumber

  @issue.Getter('gtmCommonInfo') gtmCommonInfo: object

  @layout.Mutation('updateError') updateError

  @gtm.Action('logEventWithGroups') logEventWithGroups: (payload: LogEventWidthGroupsPayload) => void

  loading: boolean = true
  aBizRegistrationNumber: string = ''
  anOwnerName: string = ''
  anAddress: string = ''
  aBizClass: string = ''
  aBizType: string = ''
  anEmail: string = ''
  aTaxRegistrationNumber: string = ''

  @Watch('bizRegistrationNumber', {immediate: true})
  __bizRegistrationNumber(value) {
    this.aBizRegistrationNumber = value
  }

  @Watch('ownerName', {immediate: true})
  __ownerName(value) {
    this.anOwnerName = value
  }

  @Watch('address', {immediate: true})
  __address(value) {
    this.anAddress = value
  }

  @Watch('bizClass', {immediate: true})
  __bizClass(value) {
    this.aBizClass = value
  }

  @Watch('bizType', {immediate: true})
  __bizType(value) {
    this.aBizType = value
  }

  @Watch('ownerEmail', {immediate: true})
  __ownerEmail(value) {
    // update 할때의 키는 email, get 할때의 키는 ownerEmail, 수정은 #209 이슈에서.
    this.anEmail = value
  }

  @Watch('taxRegistrationNumber', {immediate: true})
  __taxRegistrationNumber(value) {
    this.aTaxRegistrationNumber = value
  }

  @Watch('bizInfo', {deep: true})
  __bizInfo(value) {
    this.modifiedData = this.diffData(this.originalData, value)
  }

  get bizInfo(): UpdatePayload {
    return {
      bizRegistrationNumber: this.aBizRegistrationNumber,
      ownerName: this.anOwnerName,
      address: this.anAddress,
      bizClass: this.aBizClass,
      bizType: this.aBizType,
      email: this.anEmail,
      taxRegistrationNumber: this.aTaxRegistrationNumber,
    }
  }

  get message() {
    const {ts} = this
    return {
      title: [`${ts('my')} ${ts('biz')} ${ts('info')}를`, `${ts('input')}해주세요`],
    }
  }

  get rules() {
    const {ts} = this
    return {
      ownerName: [
        {required: true, trigger: ['blur', 'change'], message: `${ts('owner-name')}을 ${ts('input')}해주세요`},
      ],
      taxRegistrationNumber: [
        {
          trigger: ['blur', 'change'],
          validator: (_, value, callback) => {
            if(value && value.length && value.length < 4) {
              return callback(new Error(`4자리 숫자를 ${ts('input')}해주세요`))
            }
            return callback()
          }
        },
      ],
      email: [
        {
          type: 'email',
          message: `${ts('email')} 형식에 맞게 ${ts('input')}해주세요`,
          trigger: ['change', 'blur'],
        },
      ]
    }
  }

  mounted() {
    this.getBiz()
      .then(() => {
        this.setOriginalData(this.bizInfo)
      })
      .finally(() => {
        this.loading = false
        this.setInputsHandler()
      })
  }

  beforeDestroy() {
    if(this.isConfirm) {
      this.logEventWithGroups({
        eventType: 'confirm_issue_biz_info',
        eventProperties: {
          ...this.gtmCommonInfo,
          modified: this.isModifiedData,
        }
      })
    }
  }

  onClickBackward() {
    if(this.isModifiedData) {
      const {message, options} = this.confirmMessageOptions
      this.$confirm(message, options)
        .then(() => {
          this.setBizInfo(this.originalData)
        })
        .then(() => {
          this.$emit('action', 'back')
        })
        .catch((e) => e)
    } else {
      this.$emit('action', 'back')
    }
  }

  selectAddress(value = '') {
    this.anAddress = value
  }

  setBizInfo(data) {
    this.aBizRegistrationNumber = data.bizRegistrationNumber
    this.anOwnerName = data.ownerName
    this.anAddress = data.address
    this.aBizClass = data.bizClass
    this.aBizType = data.bizType
    this.anEmail = data.email
    this.aTaxRegistrationNumber = data.taxRegistrationNumber
  }

  onClickNext() {
    this.formRef.validate((valid) => {
      if(valid) {
        this.loading = true
        this.updateBiz(this.bizInfo)
          .then(() => {this.$emit('action', 'ok')})
          .catch((error) => {
            this.updateError({
              id: 'update-biz',
              message: `${this.ts('biz')}${this.ts('info')}를 저장하는데 ${this.ts('failed')}하였습니다.`,
            })
            throw error
          })
          .finally(() => {this.loading = false})
      }
    })
  }
}
